import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  lead: {},
  leads: Array(0),
}

export const createLead = createAsyncThunk(
  "leads/createLead",
  async (leadData) => {
    const token = window.localStorage.getItem("token")
    const response = await axios.post("/api/lead", leadData, {
      headers: { authorization: token },
    })
    return response.data
  }
)

export const fetchLeads = createAsyncThunk("fetchLeads", async () => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get("/api/lead", {
      headers: {
        authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.error("Error fetching leads:", err)
    throw err
  }
})

export const fetchLead = createAsyncThunk("fetchLead", async (id) => {
  try {
    const token = window.localStorage.getItem("token")
    const response = await axios.get(`/api/lead/${id}`, {
      headers: {
        authorization: token,
      },
    })
    return response.data
  } catch (err) {
    console.error("Error fetching lead:", err)
    throw err
  }
})

export const deleteLead = createAsyncThunk("leads/deleteLead", async (id) => {
  const token = window.localStorage.getItem("token")
  await axios.delete(`/api/lead/${id}`, {
    headers: { authorization: token },
  })
  return id
})

export const updateLead = createAsyncThunk(
  "leads/updateLead",
  async ({ id, updatedData }) => {
    const token = window.localStorage.getItem("token")
    const response = await axios.put(`/api/lead/${id}`, updatedData, {
      headers: { authorization: token },
    })
    return response.data
  }
)

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    setLead: (state, action) => {
      state.lead = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeads.fulfilled, (state, action) => {
        return { ...state, leads: action.payload }
      })
      .addCase(fetchLead.fulfilled, (state, action) => {
        return { ...state, lead: action.payload }
      })
      .addCase(deleteLead.fulfilled, (state, action) => {
        state.leads = state.leads.filter((lead) => lead.id !== action.payload)
      })
      .addCase(updateLead.fulfilled, (state, action) => {
        state.leads = state.leads.map((lead) =>
          lead.id === action.payload.id ? action.payload : lead
        )
      })
      .addCase(createLead.fulfilled, (state, action) => {
        state.leads.push(action.payload)
      })
  },
})

export default leadsSlice.reducer
